// frontend/src/routes/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { getUserAccess } from "../utils/userPermissions";

export default function PrivateRoute({
  children,
  roles,
  requireAdmin = false,
  requireSuperusuario = false,
  requireSuperPlus = false,
  requireSuperPlusUltra = false,
}) {
  const { user, token, loading } = React.useContext(AuthContext);
  const location = useLocation();

  if (loading || (token && !user)) {
    return <div className="p-4">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const access = getUserAccess(user);

  // Nuevo esquema recomendado basado en banderas del backend
  if (requireSuperPlusUltra && !access.canAccessSuperPlusUltra) {
    return <Navigate to="/" replace />;
  }

  if (requireSuperPlus && !access.canAccessSuperPlus) {
    return <Navigate to="/" replace />;
  }

  if (requireSuperusuario && !access.canAccessSuperusuario) {
    return <Navigate to="/" replace />;
  }

  if (requireAdmin && !access.canAccessAdmin) {
    return <Navigate to="/" replace />;
  }

  // Compatibilidad temporal con el prop legacy "roles"
  if (roles && roles.length > 0) {
    const normalizedRoles = roles.map((role) => String(role).trim().toLowerCase());

    const isAllowedByLegacyRoles =
      normalizedRoles.includes("user") ||
      normalizedRoles.includes("usuario") ||
      (normalizedRoles.includes("admin") && access.canAccessAdmin) ||
      (normalizedRoles.includes("administrador") && access.canAccessAdmin) ||
      (normalizedRoles.includes("superuser") && access.canAccessSuperusuario) ||
      (normalizedRoles.includes("superusuario") && access.canAccessSuperusuario) ||
      (normalizedRoles.includes("superusuarioplus") && access.canAccessSuperPlus) ||
      (normalizedRoles.includes("superusuarioplusultra") && access.canAccessSuperPlusUltra);

    if (!isAllowedByLegacyRoles) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}
